import React, { useRef, useEffect } from 'react'
import injectStyles from 'react-jss'
import GenericFlatButton from '../../GenericFlatButton'
import CloseIcon from 'Assets/Images/icons/modalClose'
import { styles } from './styles'
import { PERSONAL_DATA_CHANGE_REQUEST_TYPE_DOCUMENT_ENUM } from '../../../shared/constants'

const camelCaseToSentence = str => {
  // Insert a space before each uppercase letter
  const result = str.replace(/([A-Z])/g, ' $1')

  // Convert the first character to uppercase and the rest to lowercase
  return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase()
}

const ViewRequestModal = ({ requestData, onClose, classes }) => {
  const modalRef = useRef(null)
  const isNeedDescription =
    requestData.type !== PERSONAL_DATA_CHANGE_REQUEST_TYPE_DOCUMENT_ENUM

  useEffect(() => {
    const handleClickOutside = event => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose()
      }
    }

    const handleEscapeKeyPress = event => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscapeKeyPress)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscapeKeyPress)
    }
  }, [onClose])

  const oldData = requestData.oldData

  const rows = Object.entries(requestData.newData).reduce(
    (acc, newDataItem) => {
      const [newDataKey, newDataValue] = newDataItem

      const oldDataValue =
        oldData && oldData[newDataKey] ? oldData[newDataKey] : '-'

      const formattedName = camelCaseToSentence(newDataKey)
      const isNew = oldDataValue != newDataValue

      if (newDataKey === 'url') {
        const isOLDDataValuePDF = oldDataValue.endsWith('.pdf')
        const isNewDataValuePDF = newDataValue.endsWith('.pdf')
        acc.push(
          <div className={classes.modalRow}>
            {oldDataValue && oldDataValue !== '-' ? (
              <a href={oldDataValue} target="_blank" rel="noreferrer">
                {isOLDDataValuePDF ? (
                  <span>Open PDF in new tab</span>
                ) : (
                  <img
                    style={{ marginRight: '10px' }}
                    src={oldDataValue}
                    alt="img"
                  />
                )}
              </a>
            ) : (
              <div style={{ flex: isNeedDescription ? 2 : 1 }} />
            )}
            <a href={newDataValue} target="_blank" rel="noreferrer">
              {isNewDataValuePDF ? (
                <span>Open PDF in new tab</span>
              ) : (
                <img src={newDataValue} alt="img" />
              )}
            </a>
          </div>,
        )
        acc.push(<div className={classes.divider} />)
      } else {
        if (
          requestData.type !==
            PERSONAL_DATA_CHANGE_REQUEST_TYPE_DOCUMENT_ENUM &&
          newDataKey !== 'documentTypeId'
        ) {
          acc.push(
            <div className={classes.modalRow}>
              <div>{formattedName}</div>
              <div>{oldDataValue}</div>
              <div style={oldData && isNew ? { color: '#D72B4F' } : {}}>
                {newDataValue}
              </div>
            </div>,
          )
          acc.push(<div className={classes.divider} />)
        }
      }

      return acc
    },
    [],
  )

  return (
    <div className={classes.modalContainer} ref={modalRef}>
      <div className={classes.modalTitle}>{requestData.name}</div>
      <span className={classes.close} onClick={onClose}>
        <CloseIcon />
      </span>
      <div className={classes.modalRowHeader}>
        {isNeedDescription ? <div>Description</div> : null}
        <div>Old Data</div>
        <div>New Data</div>
      </div>
      <div className={classes.modalDataWrapper}>{rows}</div>
      <div className={classes.cancelButton}>
        <GenericFlatButton type={'outline'} title={'Close'} onClick={onClose} />
      </div>
    </div>
  )
}

export default injectStyles(styles)(ViewRequestModal)
